import React from 'react';

const CircularWarningIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#DA1B1B"
      d="M8 16c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8c0 2.122-.843 4.157-2.343 5.657S10.122 16 8 16zM8 1.333C4.318 1.333 1.333 4.318 1.333 8S4.318 14.667 8 14.667 14.667 11.682 14.667 8 11.682 1.333 8 1.333zm.36 8.334h-.717c-.18.001-.329-.137-.34-.316l-.305-5.667c-.004-.092.03-.182.094-.248.065-.067.153-.104.246-.103h1.326c.093 0 .181.036.246.103.064.066.098.156.095.248L8.7 9.351c-.012.179-.161.317-.34.316zm-.362 1c.552 0 1 .447 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.553.448-1 1-1z"
    />
  </svg>
);

export default CircularWarningIcon;
